import Validation from './Validation';
import CreateFlow from './CreateFlow';
import UpdateFlow from './updateFlow/UpdateFlow';

const Submit = (vm) => {
  const setModLoading = (bool) => {
    if (vm.mode !== 'create') vm.closeActive(!bool);
    vm.setLoading(bool);
  };

  const { validateBeforeSubmit } = Validation({
    mode: vm.mode,
    acceptedPolicy: vm.acceptedPolicy,
    formDataUser: vm.formDataUser,
    formDataArea: vm.formDataArea,
    message: vm.message,
  });

  const { createAccount } = CreateFlow({
    permissions: vm.permissions,
    roles: vm.roles,
    formDataUser: vm.formDataUser,
    formDataProfesional: vm.formDataProfesional,
    formDataEstudiante: vm.formDataEstudiante,
    formDataArea: vm.formDataArea,
    logout: vm.logout,
    message: vm.message,
    onBackToLogin: vm.onBackToLogin,
    onClose: vm.onClose,
    resetAll: vm.resetAll,
  });

  const { updateAccount } = UpdateFlow({
    userlogin: vm.userlogin,
    formDataUser: vm.formDataUser,
    formDataProfesional: vm.formDataProfesional,
    formDataEstudiante: vm.formDataEstudiante,
    formDataArea: vm.formDataArea,
    logout: vm.logout,
    message: vm.message,
    onBackToLogin: vm.onBackToLogin,
    onClose: vm.onClose,
    setUser: vm.setUser,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    setModLoading(true);
    if (!validateBeforeSubmit()) {
      setModLoading(false);
      return;
    }
    try {
      if (vm.mode === 'create') {
        await createAccount();
      } else {
        await updateAccount();
      }
    } catch (e) {
      vm.message(e?.message || e, 'error');
    } finally {
      setModLoading(false);
    }
  };

  return {
    handleSubmit,
  };
};

export default Submit;
